<template>
  <i-modal
    :title="title"
    :value="value"
    :dontSave="true"
    :persistent="persistent"
    :max-width="maxWidth"
    @input="$emit('input', $event)"
  >
    <v-row class="mt-4">
      <v-col cols="12">
        <div class="confirm-message">
          <slot>{{ message }}</slot>
        </div>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn text color="secondary" @click="handleNo">
          {{ $t('no') }}
        </v-btn>
        <v-btn text color="primary" @click="handleYes">
          {{ $t('yes') }}
        </v-btn>
      </v-col>
    </v-row>
  </i-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default() {
        return this.$tc('confirm', 1)
      }
    },
    message: {
      type: String,
      default: ''
    },
    persistent: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number],
      default: '500px'
    }
  },
  methods: {
    handleYes() {
      this.$emit('yes')
      this.$emit('input', false)
    },
    handleNo() {
      this.$emit('no')
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.confirm-message {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
